<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { formatBRL, markedTextSegments } from '../utils/reportFormatters';

// Coluna lateral do ranking: tipos mais buscados, mediana de preço e imóveis
// mais buscados no bairro em destaque.
const props = defineProps({
  tipos: { type: Array, default: () => [] },
  totalTipos: { type: Number, default: 0 },
  precoMediano: { type: Object, default: () => ({}) },
  operacao: { type: String, default: '' },
  tab: { type: String, default: '' },
  bairroDestaque: { type: String, default: '' },
  imoveisNoBairro: { type: Array, default: () => [] },
  totalBairroDestaque: { type: Number, default: 0 },
});

const precoMedianoTexto = computed(() => {
  if (props.precoMediano.valor == null) {
    return 'Não há volume suficiente para calcular a mediana de preço no período.';
  }

  const operacaoLabel = props.operacao === 'aluguel' ? 'aluguel' : 'venda';
  return `A mediana de preço de ${operacaoLabel} no período selecionado foi ${formatBRL(props.precoMediano.valor)}.`;
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="grid gap-6 content-start">
    <LaisCard title="Top tipo de imóveis">
      <p
        class="mb-3 text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        Tipo do imóvel
      </p>
      <ul v-if="tipos.length" class="flex flex-col gap-3">
        <li
          v-for="(item, i) in tipos.slice(0, 5)"
          :key="i"
          class="flex items-center gap-3"
        >
          <span
            class="text-[13px] text-lais-text min-w-0 flex-1 truncate font-medium"
          >
            {{ item.label }}
          </span>
          <span class="text-[12px] text-lais-text-muted tabular-nums">
            {{ totalTipos ? Math.round((item.valor / totalTipos) * 100) : 0 }}%
          </span>
        </li>
      </ul>
      <p v-else class="text-[13px] text-lais-text-muted">
        Sem dados suficientes para exibir os tipos mais buscados.
      </p>
    </LaisCard>

    <LaisCard title="Preço (R$)">
      <p class="text-[30px] font-semibold text-lais-primary font-redHatDisplay">
        {{ formatBRL(precoMediano.valor) }}
      </p>
      <p class="mt-2 text-[13px] text-lais-text-body leading-relaxed">
        {{ precoMedianoTexto }}
      </p>
    </LaisCard>

    <LaisCard
      v-if="tab === 'bairros' && bairroDestaque"
      title="IMÓVEIS MAIS BUSCADOS NESTE BAIRRO"
    >
      <template #titleAction>
        <span class="text-[12px] font-semibold text-lais-primary">
          {{ bairroDestaque }}
        </span>
      </template>
      <p class="mb-4 text-[13px] leading-relaxed text-lais-text-body">
        <template
          v-for="(segment, index) in markedTextSegments(
            `Seus imóveis em [b]${bairroDestaque}[/b] da sua prateleira atraíram mais leads.`
          )"
          :key="`bairro-narrative-${index}`"
        >
          <strong v-if="segment.bold" class="font-semibold text-lais-text">
            {{ segment.text }}
          </strong>
          <template v-else>{{ segment.text }}</template>
        </template>
      </p>
      <ul v-if="imoveisNoBairro.length" class="flex flex-col gap-3">
        <li
          v-for="(item, i) in imoveisNoBairro.slice(0, 5)"
          :key="i"
          class="flex items-center gap-3"
        >
          <span class="text-[13px] text-lais-text flex-1 truncate">
            {{ item.label }}
          </span>
          <span class="text-[12px] font-semibold text-lais-text tabular-nums">
            {{
              totalBairroDestaque
                ? Math.round((item.valor / totalBairroDestaque) * 100)
                : 0
            }}%
          </span>
        </li>
      </ul>
      <p v-else class="text-[13px] text-lais-text-muted">
        Sem imóveis com visitas suficientes neste bairro.
      </p>
    </LaisCard>
  </div>
</template>
